// Слайдеры на главной
itsoftApp.createModule("slidersOnMain", function() {

    itsoftApp.loadStyle("https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.4.2/css/swiper.min.css");
    itsoftApp.loadScript("https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.4.2/js/swiper.min.js", function() {

        $(".services__slider-button--prev").click(function() {
            $(".services__slider").find(".swiper-button-prev").click();
        });

        $(".services__slider-button--next").click(function() {
            $(".services__slider").find(".swiper-button-next").click();
        });

        var mySwiper = undefined;

        if ($(".services__slider").length) {

            $(".services__slider").addClass("is-active");

            mySwiper = new Swiper(".services__slider .swiper-container", {
                slidesPerView: 4,
                slidesPerColumn: 2,
                spaceBetween: 30,
                pagination: {
                    el: '.services__slider .swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: ".services__slider .swiper-button-next",
                    prevEl: ".services__slider .swiper-button-prev",
                },
                breakpoints: {
                // when window width is <= 320px
                480: {
                    slidesPerView: 1,
                    slidesPerColumn: 3,
                },
                // when window width is <= 480px
                768: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    lazy: {
                        loadPrevNext: true,
                    }
                },
                // when window width is <= 640px
                1020: {
                    slidesPerView: 3,
                    slidesPerColumn: 2,
                }
              }
            });

        }



        /* service work slider */

        $(".service-work__slider-button--prev").click(function() {
            $(".service-work-slider").find(".swiper-button-prev").click();
        });

        $(".service-work__slider-button--next").click(function() {
            $(".service-work-slider").find(".swiper-button-next").click();
        });

        var mySwiperSWS = undefined;

        if ($(".service-work-slider").length) {

            $(".service-work-slider").addClass("is-active");

            mySwiperSWS = new Swiper(".service-work-slider .swiper-container", {
                slidesPerView: 'auto',
                spaceBetween: 30,
                navigation: {
                    nextEl: ".service-work-slider .swiper-button-next",
                    prevEl: ".service-work-slider .swiper-button-prev",
                },
                breakpoints: {
                768: {
                    lazy: {
                        loadPrevNext: true,
                    }
                }
              }

            });

        }



        /* clients work slider */

        $(".clients__slider-button--prev").click(function() {
            $(".clients-slider").find(".swiper-button-prev").click();
        });

        $(".clients__slider-button--next").click(function() {
            $(".clients-slider").find(".swiper-button-next").click();
        });

        var mySwiperClients = undefined;

        if ($(".clients-slider").length) {

            $(".clients-slider").addClass("is-active");

            mySwiperClients = new Swiper(".clients-slider .swiper-container", {
                slidesPerView: 4,
                slidesPerColumn: 2,
                spaceBetween: 30,
                pagination: {
                    el: '.clients-slider .swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: ".clients-slider .swiper-button-next",
                    prevEl: ".clients-slider .swiper-button-prev",
                },
                breakpoints: {
                // when window width is <= 320px
                480: {
                    slidesPerView: 1,
                    slidesPerColumn: 3,
                },
                // when window width is <= 480px
                768: {
                    slidesPerView: 2,
                    slidesPerColumn: 2,
                    lazy: {
                        loadPrevNext: true,
                    }
                },
                // when window width is <= 640px
                1020: {
                    slidesPerView: 3,
                    slidesPerColumn: 2,
                }
              }
            });

        }

    });
});
